module.exports = __webpack_public_path__ + "static/media/ItemsIsItems.66982f32.jpg";